const DOMAIN = 'api.calenso.io';
const BASE_URL = 'https://' + DOMAIN;

export const environment = {
  apiUrl: BASE_URL + '/api/v1/',
  appointmentConfirmationPageUrl: 'https://dashboard.calenso.io/appointments/',
  avatarImagePath: BASE_URL + '/files/workers/avatar/',
  backgroundImagePath: BASE_URL + '/files/partners/booking_page_background_logo/',
  baseUrl: BASE_URL,
  dashboardUrl: 'https://dashboard.calenso.io',
  defaultBookingPartnerName: 'calenso',
  deployUrl: 'https://book.calenso.io',
  encryptedKey: 'FtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ',
  eventImagePath: BASE_URL + '/files/events/image/',
  brandName: 'Calenso',
  companyName: 'Calenso AG',
  brandFolder: 'calenso',
  widgetTag: 'calenso-booking',
  foundingYear: 2016,
  eventImgFallback: 'default-logo.svg',
  faviconImagePath: BASE_URL + '/files/partners/favicon_logo/',
  landingPageImagePath: BASE_URL + '/files/partners/landingpage_logo/',
  partnersImagePath: BASE_URL + '/files/partners/logo/',
  storeImagePath: BASE_URL + '/files/stores/logo/',
  production: false,
  version: '9.3.1',
  sentryDsn: 'https://143353e4fa83b1f043ad39ae84253864@o4506308503273472.ingest.sentry.io/4506467193978880',
  webcomponentWidgetUrl: 'https://webcomponent.calenso.io',
  defaultLocale: 'de_CH',
};
